export enum ReasonForPurchaseEnum {
  uninitiiased = 'Uninitialised',
  notSet = 'NotSet',
  other = 'Other',
}
